<template>
	<div class="card border-0 card-with-shadow mb-primary">
		<div
			class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center"
		>
			<h5 v-show="isDetailsEditable" class="card-title text-muted mb-0">
				{{ $t("personal_info") }}
			</h5>
			<h5 v-show="!isDetailsEditable" class="card-title text-muted mb-0">
				{{ $t("change_person") }}
			</h5>
			<div>
				<a
					href="#"
					v-show="!isDetailsEditable"
					class="text-muted"
					@click.prevent="showDetailsHide"
				>
					<app-icon stroke-width="1" name="x-square"/>
				</a>
				<a
					href="#"
					v-show="!isDetailsEditable"
					class="text-muted"
					@click.prevent="personDetailsUpdate"
				>
					<app-icon stroke-width="1" name="check-square"/>
				</a>
				<a
					href="#"
					v-if="dealStatus"
					v-show="isDetailsEditable"
					class="text-muted"
					@click.prevent="showDetailsEditable"
				>
					<app-icon stroke-width="1" name="edit"/>
				</a>
			</div>
		</div>
		<div class="card-body">
			<div v-show="isDetailsEditable">
				<template v-if="dealPersonalInfo.person_id != null">
					<div class="form-group">
						<div class="form-row">
							<label class="mb-0 text-muted col-3 d-flex align-items-center">
								{{ $t("name") }}
							</label>
							<div class="col-9" v-if="dealPersonalInfo.person">
								{{ dealPersonalInfo.person.name }}
							</div>
						</div>
					</div>
					<div class="form-group">
						<div class="form-row">
							<label class="mb-0 text-muted col-3 d-flex align-items-center">
								{{ $t("type") }}
							</label>
							<div class="col-9" v-if="dealPersonalInfo.person">
								<app-badge
									:label="dealPersonalInfo.person.contact_type.name"
									:className="`badge-sm badge-pill badge-${dealPersonalInfo.person.contact_type.class}`"
								/>
							</div>
						</div>
					</div>
					<div class="form-group mb-0">
						<div class="form-row">
							<label class="mb-0 text-muted col-3 d-flex align-items-center">
								{{ $t("owner") }}
							</label>
							<div class="col-9" v-if="dealPersonalInfo.owner">
								<div class="d-flex align-items-center">
									<app-avatar
										:title="dealPersonalInfo.owner.full_name"
										class="mr-2"
										:avatar-class="'avatars-w-30'"
										:img="
                      dealPersonalInfo.owner.profile_picture
                        ? dealPersonalInfo.owner.profile_picture.path
                        : dealPersonalInfo.owner.profile_picture
                    "
									/>
									<span>{{ dealPersonalInfo.owner.full_name }}</span>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<p class="text-muted">{{ $t("no_person_linked_yet") }}</p>
					<a href="#" class="font-size-80" @click.prevent="showDetailsEditable">
						{{ $t("link_person_with_the_deal") }}
					</a>
				</template>
			</div>
			
			<div v-show="!isDetailsEditable">
				<form ref="form">
					<div class="form-group">
						<div class="form-row align-items-center">
							<div class="col-11">
								<app-input
									type="select"
									list-value-field="name"
									:list="personList"
									:placeholder="$t('choose_one')"
									v-model="dealPersonalInfo.person_id"
								/>
							</div>
							<div class="col-1">
								<a
									href="#"
									class="text-muted"
									@click.prevent="deletePerson(dealPersonalInfo.id)"
								>
									<app-icon width="20" stroke-width="1" name="trash"/>
								</a>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";

export default {
	name: "PersonalInfo",
	props: ["dealPersonalInfo", "personList"],
	mixins: [FormMixin],
	data() {
		return {
			isDetailsEditable: true,
			personalInfo: {},
			formData: {},
			preLoader: false,
		};
	},
	computed: {
		dealStatus() {
			return (
				this.dealPersonalInfo.status.name == "status_open" &&
				this.dealPersonalInfo.status.type == "deal"
			);
		},
	},
	methods: {
		showDetailsHide() {
			this.isDetailsEditable = true;
		},
		showDetailsEditable() {
			this.isDetailsEditable = false;
		},
		personDetailsUpdate() {
			this.formData.title = this.dealPersonalInfo.title;
			this.formData.person_id = this.dealPersonalInfo.person_id;
			this.submitFromFixin('PATCH', `crm/deals/${this.dealPersonalInfo.id}`, this.formData)
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsEditable = true;
			this.$emit("update-deal");
		},
		afterError(error) {
			this.$toastr.e(error.data.message);
		},
		deletePerson(id) {
			this.axiosDelete(`crm/deal/person/delete/${id}`)
				.then((response) => {
					this.$toastr.e(response.data.message);
					this.isDetailsEditable = true;
					this.preLoader = true;
					this.$emit("update-deal");
				})
				.catch(({error}) => {
				});
		},
	},
};
</script>
